import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const UpgradeModal = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "multi-hc-upgrade-modal" */ './upgrade-modal'),
	),
	LoadingSkeleton: () => null,
});
